import { Router, NavModel, RouteConfig } from 'aurelia-router';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { MessagesService } from '../../services/messages.service';
import { I18N } from 'aurelia-i18n';
import { autoinject } from 'aurelia-framework';

@autoinject
export class NavBar {
	toggle: boolean = false;
	exitOnNext: boolean = false;
	userName: string;
	isConsumerPortalGuarantorBillingEnabled: boolean = false;
	userProfileBtnText: string = '';
	element: Element;
	sideMenuListMobile: Element;
	readonly KEYCODE_TAB = 9;
	readonly KEYCODE_ESC = 27;

	constructor(private router: Router, private globalState: State, private messagesService: MessagesService, private payrazrService: PayrazrService, private i18n: I18N) {
		this.userName = globalState.customer.name || '';
		this.isConsumerPortalGuarantorBillingEnabled = globalState.isConsumerPortalGuarantorBillingEnabled;
		this.messagesService.getMessages();
		this.userProfileBtnText = this.i18n.i18next.t('userProfileBtnText', 'User Profile Menu');
	}

	attached() {
		this.loadNavItems();
		this.element = document.querySelector('nav-bar');
		this.sideMenuListMobile = this.element.querySelector('#sideMenuListMobile');
		document.addEventListener('keydown', this.checkKeepFocus.bind(this));
	}

	loadNavItems() {
		this.router.navigation.forEach((value: NavModel) => {
			if (value.settings.fallbackText && value.title) {
				value.title = this.i18n.i18next.t(value.title, { defaultValue: value.settings.fallbackText });
			}
		});
	}

	logout() {
		this.payrazrService.logout(this.globalState.business.sessionId).then(response => {
			if (response.isSuccessful) {
				this.globalState.business.sessionId = response.entity;
				this.globalState.logout();
				this.router.navigateToRoute('login');
			}
			else {
				alert('logout failed');
			}
		});
	}

	get tabIndex(): number {
		if (this.toggle) {
			return 0;
		}
		else {
			return -1;
		}
	}

	toggleMenu() {
		this.toggle = !this.toggle;

		document.getElementById('sidebarToggle').setAttribute('aria-expanded', `${this.toggle}`);

		if (this.toggle) { // trap focus
			this.firstMobileFocusable.focus();
		}
	}

	checkKeepFocus(e: KeyboardEvent) {
		const isTabPressed = (e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB);
		const isEscPressed = (e.key === 'Escape' || e.keyCode === this.KEYCODE_ESC);

		if (isEscPressed && this.toggle) {
			this.toggleMenu();
		}

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) /* shift + tab */ {
			if (document.activeElement === this.firstMobileFocusable) {
				this.lastMobileFocusable.focus();
				e.preventDefault();
			}
		} else /* tab */ {
			if (document.activeElement === this.lastMobileFocusable) {
				this.firstMobileFocusable.focus();
				e.preventDefault();
			}
		}
	}

	navigateToRoute(route: string) {
		this.router.navigate(route);
	}

	navigateToMainContent() {
		document.querySelector('main')?.focus();
	}

	get mobileMenuFocusables(): HTMLElement[] {
		const focusables = Array.from(this.sideMenuListMobile.querySelectorAll(
			'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
		)).filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')) as HTMLElement[];
		return focusables;
	}

	get firstMobileFocusable(): HTMLElement {
		return this.mobileMenuFocusables[0];
	}

	get lastMobileFocusable(): HTMLElement {
		return this.mobileMenuFocusables[this.mobileMenuFocusables.length - 1];
	}

	get isWalletEnabled() {
		try {
			return 'consumerWalletEnabled' in this.globalState.business.portalSettings ? this.globalState.business.portalSettings.consumerWalletEnabled : true;
		}
		catch (err) {
			console.error('Failed to enable wallet.');
			return false;
		}
	}
}
